export const LOGIN = {
  SEND_OTP:'/login/initiate',
  VERIFY_OTP:'/login/verify',
  VALIDATE_ACCESS_TOKEN:'/login/validate',
  VALIDATE_REFRESH_TOKEN:'/login/refresh'
};

export const DASHBOARD  = {
  DASHBOARD_DETAILS: "/dashboard",
};

export const ADMIN = {
  LIST : "/admin",
  CREATE : "/admin",
  UPDATE : (id) => `/admin/${id}`,
  DELETE : (id) => `/admin/${id}`,
  GET : (id) => `/admin/${id}`,
};

export const CUSTOMER = {
  LIST: "/customer",
  UPDATE: (id) => `/customer/${id}`,
  GET: (id) => `/customer/${id}`,
};

export const STAFF = {
  GET: "/staff",
  POST: "/staff",
  UPDATE: (id) => `/staff/${id}`,
  GET_BY_ID: (id) => `/staff/${id}`,
  DELETE: (id) => `/staff/${id}`,
};

export const WALLET = {
  GET_BY_ID: (id) => `/wallet/${id}`,
  POST: (id) => `/wallet/${id}`,
};

export const OPERATOR = {
  GET: "/operator",
  POST: "/operator",
  UPDATE: (id) => `/operator/${id}`,
  DELETE: (id) => `/operator/${id}`,
  GET_BY_ID: (id) => `/operator/${id}`,
  ADD_KYC: "/kyc",
  UPDATE_KYC: (id) => `/kyc/${id}`,
};
  
export const ROUTE = {
  GET: "/bus-route",
  POST: "/bus-route",
  UPDATE: (id) => `/bus-route/${id}`,
  DELETE: (id) => `/bus-route/${id}`,
  ADD_FARE:"/bus-stop/add-fare",
  ADD_TRIPS:"/trip",
  DELETE_TRIP:(id) => `/trip/${id}`,
  GET_TIME_TABLE: (routeId) => `/bus/${routeId}/trip/time-table`,
};

export const BOOKING = {
  GET: "/booking",
  GET_BY_ID: (id) => `/booking/${id}`,
};

export const BUS = {
  GET: "/bus",
  POST: "/bus",
  UPDATE: (id) => `/bus/${id}`,
  DELETE: (id) => `/bus/${id}`,
  GET_BY_ID: (id) => `/bus/${id}`,
  UPLOAD_IMAGE: "/bus/images",
  UPDATE_IMAGE: (id) => `/bus/images/${id}`,
  DELETE_IMAGE: (id) => `/bus/images/${id}`,
};

export const SETTLEMENT = {
  GET: "/settlements",
  POST: "/settlements",
  UPDATE: (id) => `/settlements/${id}`,
};

export const TRANSACTION = {
  GET: "/transactions",
  UPDATE: (id) => `/transactions/${id}`,
};

export const COUPON = {
  LIST: "/coupan",
  CREATE: "/coupan",
  UPDATE: (id) => `/coupan/${id}`,
  DELETE: (id) => `/coupan/${id}`,
  GET: (id) => `/coupan/${id}`,
};

export const CITY = {
  GET: "/city",
  POST: "/city",
  UPDATE: (id) => `/city/${id}`,
  DELETE: (id) => `/city/${id}`,
  GET_BY_ID: (id) => `/city/${id}`,
  GET_ROUTES_BY_CITY_ID:`/city/getRoutes`,
};

export const POS = {
  GET: "/pos/buses",
  GET_BY_BUS :`/pos/bookings/by-bus`,
  GET_TICKET_DETAILS :(id) =>`/pos/bookings/ticket/${id}`,
};

export const REPORT = {
  LIST: "/reports",
  GET_EXPENSES: (id) => `/expenses/${id}`,
};

export const REFFERAL = {
  GET: "/referral",
  GET_BY_ID: (code) => `/referral/code/${code}`,
};

export const FAQ = {
  GET: "/faq",
  POST: "/faq",
  UPDATE: "/",
  DELETE: "",
  GET_BY_ID: "",
};

export const BANK = {
  GET: "/bank",
  UPDATE: (id) => `/bank/${id}`,
  GET_BY_ID: (id) => `/bank/${id}`,
};

export const ADVERTISEMENT = {
  GET_ADVERTISEMENTS: "/advertisement",
  POST: "/advertisement",
  UPDATE: (id) => `/advertisement/${id}`,
  GET_BY_ID: (id) => `/advertisement/${id}`,
  GET_METRICS: (id) => `/advertisement/metrics/${id}`,
  DELETE: (id) => `/advertisement/${id}`,
};

export const SYSTERM_SETTINGS = {
  POST: "/system-settings",
  GET : '/system-settings',
  UPDATE: (id) => `/system-settings/${id}`,
  GET_BY_ID: (key) => `/system-settings/${key}`,
  DELETE: (key) => `/system-settings/${key}`,
};
